import { faBarcodeRead, faSearch } from '@fortawesome/pro-solid-svg-icons';
import { Icon } from 'src/components/Icon';
import { Stack } from 'src/components/Stack';
import { InputAdornment, TextField } from 'src/components/TextField';

import { usePosContext } from '../PosContext';


export const PosProductListFilter = () => {
  const { search, handleSearchChange } = usePosContext();
  return (
    <Stack width="100%">
      <TextField
        placeholder="Search"
        fullWidth
        value={search}
        onChange={(e) => handleSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon
                icon={faSearch}
                sx={{ cursor: 'pointer' }}
              />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <Icon
                icon={faBarcodeRead}
                sx={{ cursor: 'pointer' }}
              />
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  );
};
